import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { get } from '../../utils/api';
import { getUserLanguage } from '../../utils/language';
import { IMAGE_BASE_URL } from '../../config';
import { formatDate } from '../../utils/formatters';

const LatestBlogPosts = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const language = getUserLanguage();

  useEffect(() => {
    const fetchLatestPosts = async () => {
      try {
        const headers = { 'accept-language': language };
        const response = await get('/blog?limit=3', headers);
        setPosts(response.posts || []);
      } catch (error) {
        console.error('Error fetching latest blog posts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchLatestPosts();
  }, [language]);

  if (loading || posts.length === 0) {
    return null;
  }

  return (
    <section className="py-16 bg-black">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-title font-bold text-white mb-2">
            {language === 'cs' ? 'Nejnovější příspěvky' : 'Latest Blog Posts'}
          </h2>
          <div className="gradient-line-center mb-4"></div>
          <p className="text-gray-400 max-w-2xl mx-auto">
            {language === 'cs'
              ? 'Přečtěte si naše nejnovější novinky, tipy a zážitky ze světa driftu'
              : 'Check out our latest news, tips, and experiences from the world of drifting'}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {posts.map((post) => (
            <Link
              key={post.id}
              to={`/blog/${post.slug}`}
              className="drift-card group"
            >
              <div className="relative h-48 overflow-hidden">
                {post.image_path ? (
                  <img
                    src={import.meta.env.DEV ? post.image_path : `${IMAGE_BASE_URL}${post.image_path}`}
                    alt={post.title || 'Blog post'}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                ) : (
                  <div className="no-image-placeholder h-full w-full">
                    No Image
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent"></div>
              </div>
              <div className="p-6">
                <div className="mb-2 text-sm text-gray-400">
                  {formatDate(post.published_date)}
                </div>
                <h3 className="text-xl font-title font-bold text-white group-hover:text-red-500 transition-colors mb-2">
                  {post.title}
                </h3>
                <div className="gradient-line mb-4"></div>
                <p className="text-gray-400 text-sm mb-4 line-clamp-3">
                  {post.summary}
                </p>
                <span className="text-red-500 hover:text-red-600 transition-colors text-sm font-bold">
                  {language === 'cs' ? 'Číst více' : 'Read more'} →
                </span>
              </div>
            </Link>
          ))}
        </div>
        <div className="text-center mt-12">
          <a href="/blog" className="btn-outline">
            <i className="fas fa-images text-xs mr-2"></i>
            {language === 'cs' ? 'Zobrazit všechny příspěvky' : 'View all posts'}
          </a>
        </div>
      </div>
    </section>
  );
};

export default LatestBlogPosts;